import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faStar } from '@fortawesome/free-solid-svg-icons';
import { StatusBadge } from '@medprompt/shared';
import { MeasurementSignificanceEnum } from '../enums/measurementTypeEnum';

const MEASUREMENT_SIGNIFICANCE_ICONS = {
  star: faStar,
  plus: faPlus,
};

export const MEASUREMENT_SIGNIFICANCE_FILTER_OPTIONS = Object.values(MeasurementSignificanceEnum).map(
  (entry) => entry.value
);

/** useTableState persists disabledFilters as an array; Table expects a Set */
export const asDisabledFilterSet = (disabledFilters) => {
  if (disabledFilters instanceof Set) return disabledFilters;
  if (Array.isArray(disabledFilters)) return new Set(disabledFilters);
  return new Set();
};

export const renderMeasurementSignificanceBadge = (value) => {
  const meta = MeasurementSignificanceEnum[value];
  if (!meta) return value;
  const icon = MEASUREMENT_SIGNIFICANCE_ICONS[meta.icon];
  const labelContent = icon
    ? <><FontAwesomeIcon icon={icon} style={{ marginRight: 4 }} />{meta.label}</>
    : meta.label;
  return (
    <StatusBadge
      label={labelContent}
      colorFamily={meta.colorFamily || 'gray'}
      size="normal"
    />
  );
};

export const renderOptionalCell = (value) => value || '—';

export const renderSnomedCodeCell = (value) => {
  if (!value) return '—';
  if (String(value).startsWith('CUSTOM')) return 'N.A.';
  return value;
};
